import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class HblInven extends TrackableEntity {
    id: number = 0;
    tbName: string = '';
    tbId: number = 0;
    seq: number = 0;
    length: number = 0;
    width: number = 0;
    height: number = 0;
    pcs: number = 0;
    chgWeight: number = 0;
    lChgWeight: number = 0;
    state: string = '';
    volCm: boolean = false;
    inventId: number = 0;

    constructor(init?:Partial<HblInven>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'state', 'inventId');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return HblInven.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_AOINV' }),
        'length': new DBMappingInfo({ field: 'F_LENGTH', table: 'T_AOINV' }),
        'width': new DBMappingInfo({ field: 'F_WIDTH', table: 'T_AOINV' }),
        'height': new DBMappingInfo({ field: 'F_HEIGHT', table: 'T_AOINV' }),
        'pcs': new DBMappingInfo({ field: 'F_PCS', table: 'T_AOINV' }),
        'chgWeight': new DBMappingInfo({ field: 'F_CHGWEIGHT', table: 'T_AOINV' }),
        'lChgWeight': new DBMappingInfo({ field: 'F_LCHGWEIGHT', table: 'T_AOINV' }),
        'tbId': new DBMappingInfo({ field: 'F_TBID', table: 'T_AOINV' }),
        'tbName': new DBMappingInfo({ field: 'F_TBNAME', table: 'T_AOINV' }),
    };
}
